import axios from 'axios'
export default {

  async add (obj, img) {
    try {
      obj.updated_at = Date.now()
      obj.created_at = Date.now()
      delete obj._id

      const response = await axios.post('products/add', obj)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'product')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('products agregada correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al agregar products:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al agregar products:', error)
      return false
    }
  },

  async edit (obj, img) {
    try {
      obj.updated_at = Date.now()
      const response = await axios.patch('products/update', obj)
      if (response.status === 200) {
        if (img != null) {
          const formData = new FormData()
          formData.append('file', img)
          formData.append('_id', response.data._id)
          formData.append('type', 'product')
          await axios.post('files/add', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
        }
        console.log('products editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar products:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar products:', error)
      return false
    }
  },

  async listByBussines (businesId, search, page, limit) {
    try {
      const response = await axios.get('products/listByBusiness?business=' + businesId +
        '&search=' + search +
        '&page=' + page +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByPos (terminalId, search, page, limit) {
    try {
      const response = await axios.get('products/listByPos?terminal=' + terminalId +
        '&search=' + search +
        '&page=' + page +
        '&limit=' + limit)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async delete (obj) {
    try {
      obj.deleted_at = Date.now()
      const response = await axios.patch('products/delete', obj)
      if (response.status === 200) {
        console.log('products editado correctamente:', response.data)
        return true
      } else {
        console.log('Hubo un problema al editar el products:', response.data)
        return false
      }
    } catch (error) {
      console.error('Error al editar el products:', error)
      return false
    }
  },

  async listByCategory (categoryId, search) {
    try {
      const response = await axios.get('products/productsByCategory?category=' + categoryId + '&search=' + search)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listByFavorites (terminalId, search) {
    try {
      const response = await axios.get('products/productsByFavorites?terminal=' + terminalId + '&search=' + search)
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async listAllByPos (terminalId) {
    try {
      const response = await axios.get('products/listByPos?terminal=' + terminalId + '&page=1' + '&limit=10000')
      return response.data
    } catch (error) {
      console.error(error)
      return []
    }
  },

  async byId (id) {
    try {
      const response = await axios.get('products/productsById?id=' + id)
      return response.data
    } catch (error) {
      console.error(error)
      return null
    }
  }

}
